import React from 'react'
import styles from './index.module.scss'
import classnames from 'classnames'

export function Splash() {
  return (
    <div className={styles.splash}>
      <div className={styles.splash_container}>
        <img
          src="https://static-1253442168.image.myqcloud.com/picture/6163375_8ff5cb81f7e43310afc95bbc35ffcb06.jpg"
          alt="荔枝微课 logo"
        />
        <p className={styles.title}>荔枝微课</p>
        <p className={styles.index_tips}>成长每时每刻</p>
        <div className={styles.sk_wave}>
          <div className={classnames(styles.sk_rect, styles.sk_rect1)}></div>
          <div className={classnames(styles.sk_rect, styles.sk_rect2)}></div>
          <div className={classnames(styles.sk_rect, styles.sk_rect3)}></div>
          <div className={classnames(styles.sk_rect, styles.sk_rect4)}></div>
          <div className={classnames(styles.sk_rect, styles.sk_rect5)}></div>
        </div>
      </div>
    </div>
  )
}
